import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

//import PageAdminPermissions from '~/app/pages/private/page-admin-permissions/PageAdminPermissions.vue'
//import PageAdminUser from '~/app/pages/private/page-admin-user/PageAdminUser.vue'

// Утилитная функция для проверки токена без композаблов
const getAuthTokenFromStorage = (): string | null => {
    try {
        const token = localStorage.getItem('token')
        return token ? JSON.parse(token) : null
    } catch {
        return null
    }
}

const isUserAuthenticated = (): boolean => {
    return !!getAuthTokenFromStorage()
}

const routes: RouteRecordRaw[] = [
    {
        path: '/auth',
        children: [
            {
                path: 'sign-in',
                name: 'page-auth-signin',
                component: () => {
                    return import('~/app/pages/public/page-auth-signin/PageAuthSignIn.vue')
                },
            },
        ],
    },
    {
        path: '/',
        component: () => {
            return import('~/widgets/layout/ui/Layout.vue')
        },
        children: [
            {
                path: '',
                name: 'page-home',
                component: () => {
                    return import('~/app/pages/private/page-home/PageHome.vue')
                },
            },
            {
                path: 'admin-users',
                name: 'page-admin-users',
                component: () => {
                    return import('~/app/pages/private/page-admin-users/PageAdminUsers.vue')
                },
            },
            {
                path: 'admin-users/:id',
                name: 'page-admin-user',
                component: () => {
                    return import('~/app/pages/private/page-admin-user/PageAdminUser.vue')
                },
            },
            {
                path: 'create-business',
                name: 'page-create-business',
                component: () => {
                    return import('~/app/pages/private/page-create-business/PageCreateBusiness.vue')
                },
            },
            {
                path: 'edit-business/:id',
                name: 'page-edit-business',
                component: () => {
                    return import('~/app/pages/private/page-create-business/PageCreateBusiness.vue')
                },
            },
            /* {
                path: 'admin-users/:id/permissions',
                name: 'page-composables-permissions',
                component: PageAdminPermissions,
            },
            {
                path: 'admin/permissions',
                name: 'page-admin-permission',
                component: PageAdminPermissions,
            }, */
        ],
    },

    {
        path: '/:pathMatch(.*)*',
        redirect: () => {
            return isUserAuthenticated()
                ? { name: 'page-home' }
                : { name: 'page-auth-signin' }
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, _, next) => {
    const isAuthenticated = isUserAuthenticated()

    if (to.name === 'page-auth-signin' || to.name === 'page-auth-signup') {
        return isAuthenticated ? next({ name: 'page-home' }) : next()
    }

    if (!isAuthenticated) {
        return next({ name: 'page-auth-signin' })
    }

    return next()
})

export default router
